// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
/* eslint-disable */

import { initFormatters } from './formatters'
import type { Locales, Translations } from './i18n-types'
import { loadedFormatters, loadedLocales, locales } from './i18n-util'

import cs from './cs'
import en from './en'

import cs_countries from './cs/countries'
import cs_zod from './cs/zod'
import en_countries from './en/countries'
import en_zod from './en/zod'

const localeTranslations = {
	cs: {
		...cs,
		countries: cs_countries,
		zod: cs_zod
	},
	en: {
		...en,
		countries: en_countries,
		zod: en_zod
	},
}

export const loadLocale = (locale: Locales): void => {
	if (loadedLocales[locale]) return

	loadedLocales[locale] = localeTranslations[locale] as unknown as Translations
	loadFormatters(locale)
}

export const loadAllLocales = (): void => locales.forEach(loadLocale)

export const loadFormatters = (locale: Locales): void =>
	void (loadedFormatters[locale] = initFormatters(locale))
